/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  SendMessageRequestBody,
  SendMessageRequestBody$Outbound,
  SendMessageRequestBody$outboundSchema,
} from "../components/sendmessagerequestbody.js";

export type SendAssistantMessageSecurity = {
  projectSlugHeaderGramProject?: string | undefined;
  sessionHeaderGramSession?: string | undefined;
};

export type SendAssistantMessageRequest = {
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
  sendMessageRequestBody: SendMessageRequestBody;
};

/** @internal */
export type SendAssistantMessageSecurity$Outbound = {
  "project_slug_header_Gram-Project"?: string | undefined;
  "session_header_Gram-Session"?: string | undefined;
};

/** @internal */
export const SendAssistantMessageSecurity$outboundSchema: z.ZodMiniType<
  SendAssistantMessageSecurity$Outbound,
  SendAssistantMessageSecurity
> = z.pipe(
  z.object({
    projectSlugHeaderGramProject: z.optional(z.string()),
    sessionHeaderGramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function sendAssistantMessageSecurityToJSON(
  sendAssistantMessageSecurity: SendAssistantMessageSecurity,
): string {
  return JSON.stringify(
    SendAssistantMessageSecurity$outboundSchema.parse(
      sendAssistantMessageSecurity,
    ),
  );
}

/** @internal */
export type SendAssistantMessageRequest$Outbound = {
  "Gram-Session"?: string | undefined;
  "Gram-Project"?: string | undefined;
  SendMessageRequestBody: SendMessageRequestBody$Outbound;
};

/** @internal */
export const SendAssistantMessageRequest$outboundSchema: z.ZodMiniType<
  SendAssistantMessageRequest$Outbound,
  SendAssistantMessageRequest
> = z.pipe(
  z.object({
    gramSession: z.optional(z.string()),
    gramProject: z.optional(z.string()),
    sendMessageRequestBody: SendMessageRequestBody$outboundSchema,
  }),
  z.transform((v) => {
    return remap$(v, {
      gramSession: "Gram-Session",
      gramProject: "Gram-Project",
      sendMessageRequestBody: "SendMessageRequestBody",
    });
  }),
);

export function sendAssistantMessageRequestToJSON(
  sendAssistantMessageRequest: SendAssistantMessageRequest,
): string {
  return JSON.stringify(
    SendAssistantMessageRequest$outboundSchema.parse(
      sendAssistantMessageRequest,
    ),
  );
}
